import { useStringResource } from '@garner-health/lib-ui-content-management';
// A throttled request has nothing to show, so it reuses the empty-results illustration.
import RateLimitedSvg from 'jsx:~/assets/images/empty-search-results.svg';
import React from 'react';

import { SvgWithSubText } from './svg-with-text';

/**
 * Shown when the gateway throttles a provider-search request (HTTP 429). Distinct from the generic
 * error page so a throttled user is told to wait rather than that DataPro is broken.
 */
export const RateLimited = () => {
  const header = useStringResource('main', 'rateLimitedHeader');
  const subHeader = useStringResource('main', 'rateLimitedSubheader');

  return (
    <SvgWithSubText svg={<RateLimitedSvg role="img" aria-label={header} />} header={header} subHeader={subHeader} />
  );
};
